/** @format */

import React from "react";
import Gleap from "gleap";
//import modules
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import allRoutes from "./utilities/Routes";

const App = () => {
  Gleap.initialize("ZTYLB9oc7l0RO7ZXrvlYwVR4JA0YUiJw");
  return (
    <div className="app">
      <BrowserRouter>
        <Routes>
          {allRoutes.map(({ path, Component }, key) => (
            <Route path={path} element={Component} key={key} />
          ))}
        </Routes>
      </BrowserRouter>
      <ToastContainer autoClose={3000} />
    </div>
  );
};

export default App;
